"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoastalErosionPlan$ = exports.CoastalErosionPlan$outboundSchema = exports.CoastalErosionPlan$inboundSchema = void 0;
exports.coastalErosionPlanToJSON = coastalErosionPlanToJSON;
exports.coastalErosionPlanFromJSON = coastalErosionPlanFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const coastalerosionnoactiveintervention_js_1 = require("./coastalerosionnoactiveintervention.js");
const coastalerosionshoremanagementplan_js_1 = require("./coastalerosionshoremanagementplan.js");
const meta_js_1 = require("./meta.js");
/** @internal */
exports.CoastalErosionPlan$inboundSchema = z.object({
    boundary: z.nullable(z.string()),
    defence_type: z.nullable(z.string()),
    distance_from_point: z.nullable(z.number().int()),
    feature_id: z.nullable(z.string()),
    feature_type: z.nullable(z.string()),
    floodable: z.nullable(z.boolean()),
    meta: meta_js_1.Meta$inboundSchema,
    mid_point: z.nullable(z.string()),
    no_active_intervention: z.nullable(coastalerosionnoactiveintervention_js_1.CoastalErosionNoActiveIntervention$inboundSchema),
    shore_management_plan: z.nullable(coastalerosionshoremanagementplan_js_1.CoastalErosionShoreManagementPlan$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "defence_type": "defenceType",
        "distance_from_point": "distanceFromPoint",
        "feature_id": "featureId",
        "feature_type": "featureType",
        "mid_point": "midPoint",
        "no_active_intervention": "noActiveIntervention",
        "shore_management_plan": "shoreManagementPlan",
    });
});
/** @internal */
exports.CoastalErosionPlan$outboundSchema = z.object({
    boundary: z.nullable(z.string()),
    defenceType: z.nullable(z.string()),
    distanceFromPoint: z.nullable(z.number().int()),
    featureId: z.nullable(z.string()),
    featureType: z.nullable(z.string()),
    floodable: z.nullable(z.boolean()),
    meta: meta_js_1.Meta$outboundSchema,
    midPoint: z.nullable(z.string()),
    noActiveIntervention: z.nullable(coastalerosionnoactiveintervention_js_1.CoastalErosionNoActiveIntervention$outboundSchema),
    shoreManagementPlan: z.nullable(coastalerosionshoremanagementplan_js_1.CoastalErosionShoreManagementPlan$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        defenceType: "defence_type",
        distanceFromPoint: "distance_from_point",
        featureId: "feature_id",
        featureType: "feature_type",
        midPoint: "mid_point",
        noActiveIntervention: "no_active_intervention",
        shoreManagementPlan: "shore_management_plan",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CoastalErosionPlan$;
(function (CoastalErosionPlan$) {
    /** @deprecated use `CoastalErosionPlan$inboundSchema` instead. */
    CoastalErosionPlan$.inboundSchema = exports.CoastalErosionPlan$inboundSchema;
    /** @deprecated use `CoastalErosionPlan$outboundSchema` instead. */
    CoastalErosionPlan$.outboundSchema = exports.CoastalErosionPlan$outboundSchema;
})(CoastalErosionPlan$ || (exports.CoastalErosionPlan$ = CoastalErosionPlan$ = {}));
function coastalErosionPlanToJSON(coastalErosionPlan) {
    return JSON.stringify(exports.CoastalErosionPlan$outboundSchema.parse(coastalErosionPlan));
}
function coastalErosionPlanFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CoastalErosionPlan$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CoastalErosionPlan' from JSON`);
}
//# sourceMappingURL=coastalerosionplan.js.map